import Tab from "@mui/joy/Tab";
import TabList from "@mui/joy/TabList";
import TabPanel from "@mui/joy/TabPanel";
import Tabs from "@mui/joy/Tabs";
import { useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import AppNavbar from "../../components/shared/AppNavbar/AppNavbar";
import Footer from "../../components/shared/Footer/Footer";
import withNavigateHook from "../../hooks/withNavigateHook";
import LeftArrow from "../../images/arrow-left_grey.svg";
import "./AboutPage.scss";
import { useConfig } from "../../context/ConfigContext";

function AboutPage() {
  const location = useLocation();
  const { config } = useConfig();
  const [RestorentFilter, setRestorentFilter] = useState("");

  const apropos: boolean = location.pathname === "/apropos-politique";
  const ScrollTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="Apropos">
      <AppNavbar
        setRestorentFilter={setRestorentFilter}
        RestorentFilter={RestorentFilter}
      />
      <div className="BodyPage">
        <div className="TopPageHeader">
          <Link to="/">
            <div>
              <img src={LeftArrow} alt="" />
              <p>À propos</p>
            </div>
          </Link>
        </div>

        <Tabs className="Tabs" aria-label="Vertical tabs" orientation="vertical">
          <div className="TabNavigation">
            {!apropos ? (
              <TabList>
                <Tab>
                  <p onClick={ScrollTop}>Conditions générales d’utilisation</p>
                </Tab>
                <Tab>
                  <p onClick={ScrollTop}>Politique de confidentialité</p>
                </Tab>
              </TabList>
            ) : (
              <TabList>
                <Tab>
                  <p onClick={ScrollTop}>Politique de confidentialité</p>
                </Tab>
                <Tab>
                  <p onClick={ScrollTop}>Conditions générales d’utilisation</p>
                </Tab>
              </TabList>
            )}
          </div>

          <div className="TabContent">
            {/* CONDITIONS GÉNÉRALES */}
            <TabPanel value={apropos ? 1 : 0}>
              <b>1. Conditions</b>
              <p>
                En accédant au site web à l’adresse <strong>fioeat.com</strong>, vous acceptez d’être lié par les présentes conditions d’utilisation, ainsi que par toutes les lois et réglementations applicables. Vous vous engagez à respecter les lois locales en vigueur. 
                Si vous n’acceptez pas ces conditions, il vous est interdit d’utiliser ou d’accéder à ce site. 
                Le contenu de ce site web est protégé par les droits d’auteur et les droits des marques.
              </p>

              <b>2. Licence d’utilisation</b>
              <p>
                L’autorisation est accordée de télécharger temporairement une copie du contenu (informations ou logiciels) sur le site web de <strong>Frenchinnov</strong> à des fins de visualisation personnelle et non commerciale. 
                Il s’agit d’une licence, non d’un transfert de propriété. En vertu de cette licence, vous ne pouvez pas :
              </p>
              <ul>
                <li>Modifier ou copier le contenu ;</li>
                <li>Utiliser le contenu à des fins commerciales ou pour tout affichage public (commercial ou non commercial) ;</li>
                <li>Tenter de décompiler ou de désassembler tout logiciel figurant sur le site web de Frenchinnov ;</li>
                <li>Supprimer tout droit d’auteur ou toute autre mention de propriété du contenu ;</li>
                <li>Transférer les documents à une autre personne ou les dupliquer sur un autre serveur.</li>
              </ul>

              <b>3. Déni de responsabilité</b>
              <p>
                Le matériel sur le site web de <strong>Frenchinnov</strong> est fourni « tel quel ». Frenchinnov n’offre aucune garantie, explicite ou implicite, et décline par la présente toute autre garantie, y compris, mais sans s’y limiter, les garanties implicites de qualité marchande, d’adéquation à un usage particulier, de non-violation des droits de propriété intellectuelle ou d’autres violations des droits. 
                En outre, Frenchinnov ne garantit ni l’exactitude, ni la fiabilité, ni les résultats probables de l’utilisation des informations présentes sur son site web ou tout autre site lié.
              </p>
            </TabPanel>

            {/* POLITIQUE DE CONFIDENTIALITÉ */}
            <TabPanel value={apropos ? 0 : 1}>
              <b>1. Quelles informations collectons-nous ?</b>
              <p>
                Nous collectons les informations personnelles que vous nous fournissez volontairement :
              </p>
              <ul>
                <li>Nom et prénom</li>
                <li>Email</li>
                <li>Adresse</li>
                <li>Mot de passe</li>
                <li>Numéro de téléphone</li>
                <li>Localisation et géolocalisation</li>
              </ul>
              <p>
                Les informations collectées dépendent du contexte de votre interaction avec nos services. 
                Vous êtes libre de refuser de nous fournir certaines informations, mais cela peut limiter votre accès à certains services.
              </p>

              <b>2. Comment utilisons-nous vos informations ?</b>
              <p>
                Nous collectons uniquement les informations nécessaires pour vous fournir un service. 
                Ces données sont recueillies de manière licite, avec votre consentement et votre connaissance. 
                Nous vous expliquons toujours pourquoi elles sont collectées et comment elles seront utilisées. 
                Les informations sont conservées uniquement le temps nécessaire pour la prestation du service demandé et sont protégées par des moyens de sécurité adaptés.
              </p>
              <p>Nous utilisons vos informations pour :</p>
              <ul>
                <li>Faciliter la création de votre compte (via Google ou Facebook, si autorisé) ;</li>
                <li>Surveiller et prévenir la fraude ;</li>
                <li>Répondre à des demandes légales ;</li>
                <li>Gérer les comptes utilisateurs ;</li>
                <li>Fournir les services que vous avez choisis ;</li>
                <li>Analyser les données pour améliorer nos services.</li>
              </ul>

              <b>3. Avec qui partageons-nous vos informations ?</b>
              <p>
                Nous ne partageons pas vos informations personnelles publiquement. 
                Certaines données peuvent être partagées avec des tiers pour des besoins spécifiques :
              </p>
              <ul>
                <li><strong>Restaurants partenaires</strong> : identification du destinataire d’une commande ;</li>
                <li><strong>Stripe</strong> : traitement sécurisé des paiements ;</li>
                <li><strong>Azure</strong> : hébergement et infrastructure de stockage des données ;</li>
                <li><strong>Facebook</strong> et <strong>Google</strong> : authentification et géolocalisation.</li>
              </ul>
              <p>
                Nous partageons également certaines informations lorsque la loi l’exige. 
                Notre site peut contenir des liens vers des sites externes que nous ne gérons pas ; nous ne sommes pas responsables de leurs politiques de confidentialité.  
                En continuant d’utiliser notre site, vous acceptez nos pratiques en matière de données personnelles. 
                Pour toute question sur la manière dont nous traitons vos données, n’hésitez pas à nous contacter.
              </p>
            </TabPanel>
          </div>
        </Tabs>
      </div>
      {config?.isGlobalWebsite && <Footer />}
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  location: state.auth.location,
  token: state.auth.token,
  userInfo: state.auth.userInfo,
});

export default connect(mapStateToProps)(withNavigateHook(AboutPage));
